import React from 'react';

import UIcon from 'Components/unit/UIcon/UIcon';

import styles from '../Item.styles';

interface UserEventsProps {
  likes?: number | null;
  views?: number | null;
  type: string;
}

const UserEvents: React.FC<UserEventsProps> = ({ likes, views, type }) => (
  <div style={styles.containerUserEvents}>
    <div style={styles.containerUserEvent}>
      <div style={styles.textUserEvent} data-test-id="likes-nb">
        {`${likes ?? 0}`}
      </div>
      <UIcon name="candidates-like" size={16} />
    </div>

    {type === 'breaking-news' && (
      <div style={styles.containerUserEvent}>
        <div style={styles.textUserEvent} data-test-id="views-nb">
          {`${views ?? 0}`}
        </div>
        <UIcon name="eye" size={16} />
      </div>
    )}
  </div>
);

export default UserEvents;
